import { render } from "./EditarCentroCosto.vue?vue&type=template&id=2c573030&scoped=true"
import script from "./EditarCentroCosto.vue?vue&type=script&lang=js"
export * from "./EditarCentroCosto.vue?vue&type=script&lang=js"

import "./EditarCentroCosto.vue?vue&type=style&index=0&id=2c573030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c573030"]])

export default __exports__